export default __webpack_public_path__ + "static/job1-cc1a116fe775b3e7162e5fa1310eba09.jpg";